<template>
  <div class="w-full px-6 py-4">
    <div class="border rounded-md overflow-hidden">
      <div
        class="flex items-center justify-between odd:bg-gray-50 dark:odd:bg-gray-800/30 py-2 px-4"
      >
        <div class="max-w-sm">
          <p class="font-semibold text-sm leading-none">
            {{ $t('notifications.toggleAll') }}
          </p>
        </div>

        <div class="flex text-sm -space-x-px">
          <button
            class="py-1 px-3 border rounded-l-md transition"
            :class="_apps ? 'text-white bg-primary-600 border-white z-10' : 'text-gray-500 dark:text-gray-400 hover:bg-gray-100'"
            @click="_apps = !_apps"
          >
            {{ $t('notifications.apps') }}
          </button>
          <button
            class="py-1 px-3 border transition"
            :class="_email ? 'text-white bg-primary-600 border-white z-10' : 'text-gray-500 dark:text-gray-400 hover:bg-gray-100'"
            @click="_email = !_email"
          >
            {{ $t('general.email') }}
          </button>
          <button
            class="py-1 px-3 border rounded-r-md transition"
            :class="_push ? 'text-white bg-primary-600 border-white z-10' : 'text-gray-500 dark:text-gray-400 hover:bg-gray-100'"
            @click="_push = !_push"
          >
            {{ $t('notifications.push') }}
          </button>
        </div>
      </div>
      <div
        v-for="(notification, key) in _employee.alertNotificationSettings"
        :key="key"
        class="flex items-center justify-between odd:bg-gray-50 dark:odd:bg-gray-800/30 py-2 px-4"
      >
        <div v-if="Notifications[key]" class="max-w-sm">
          <p class="text-sm leading-none mb-1">
            {{ $t(Notifications[key].name) }}
          </p>
          <p class="opacity-80 text-sm leading-tight">
            {{ $t(Notifications[key].information) }}
          </p>
        </div>

        <div v-else class="max-w-sm">
          <p class="text-sm leading-none mb-1">
            {{ $t(notification.name) }}
          </p>
        </div>

        <div class="flex text-sm -space-x-px">
          <button
            class="py-1 px-3 border rounded-l-md transition"
            :class="notification.apps ? 'text-white bg-primary-600 border-white dark:bg-primary-900 dark:border-primary-950 z-10' : 'text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover-gray-800'"
            @click="_employee.alertNotificationSettings[key].apps = !_employee.alertNotificationSettings[key].apps"
          >
            {{ $t('notifications.apps') }}
          </button>
          <button
            class="py-1 px-3 border transition"
            :class="notification.email ? 'text-white bg-primary-600 border-white dark:bg-primary-900 dark:border-primary-950 z-10' : 'text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover-gray-800'"
            @click="_employee.alertNotificationSettings[key].email = !_employee.alertNotificationSettings[key].email"
          >
            {{ $t('general.email') }}
          </button>
          <button
            class="py-1 px-3 border rounded-r-md transition"
            :class="notification.push ? 'text-white bg-primary-600 border-white dark:bg-primary-900 dark:border-primary-950 z-10' : 'text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover-gray-800'"
            @click="_employee.alertNotificationSettings[key].push = !_employee.alertNotificationSettings[key].push"
          >
            {{ $t('notifications.push') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { Notifications } from './notificationTypes'

interface Props {
  employee: Record<string, any>
}

const props = defineProps<Props>()

const emit = defineEmits<{
  (e: 'update:employee', value: Record<string, any>): void
}>()

const _employee = computed({
  get () {
    return props.employee
  },
  set (value) {
    emit('update:employee', value)
  },
})

const _apps = computed({
  get () {
    return Object.values(_employee.value.alertNotificationSettings)
      .every((item: any) => {
        return item.apps
      })
  },
  set (value: boolean) {
    for (const key of Object.keys(_employee.value.alertNotificationSettings)) {
      _employee.value.alertNotificationSettings[key].apps = value
    }
  },
})

const _email = computed({
  get () {
    return Object.values(_employee.value.alertNotificationSettings)
      .every((item: any) => {
        return item.email
      })
  },
  set (value: boolean) {
    for (const key of Object.keys(_employee.value.alertNotificationSettings)) {
      _employee.value.alertNotificationSettings[key].email = value
    }
  },
})

const _push = computed({
  get () {
    return Object.values(_employee.value.alertNotificationSettings)
      .every((item: any) => {
        return item.push
      })
  },
  set (value: boolean) {
    for (const key of Object.keys(_employee.value.alertNotificationSettings)) {
      _employee.value.alertNotificationSettings[key].push = value
    }
  },
})
</script>

